import { Injectable } from "@angular/core";
import { UploadFileHistory } from "../../interfaces/upload-file-history/upload-file-history.interface";
import { PagedApiResponse } from "../../types/shared/paged-api-response.type";
import { BaseMapper } from "../shared/base.mapper";

@Injectable()
export class UploadFileHistoryMapper extends BaseMapper<UploadFileHistory> {
    mapPagedApiResponse<T>(
        data: any,
        mapper: (data: any, objectType?: any) => Array<T>,
        objectType?: any
    ): PagedApiResponse<T> {
        const response = new PagedApiResponse<T>();
        response.count = data.count;
        response.rows = mapper(data.rows, objectType);

        return response;
    }
}
